import { render, staticRenderFns } from "./SubLevel.vue?vue&type=template&id=ed18f4c4&"
import script from "./SubLevel.vue?vue&type=script&lang=js&"
export * from "./SubLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports